import { HubError } from "../class/Error";

export const _getTickerPrice = async <T>(
  uri: string,
  method: RequestInit["method"],
  json?: any
): Promise<T> => {
  const response = await fetch(`${uri}`, {
    method: method,
    body: json && JSON.stringify(json),
  });

  if (!response.ok) {
    await HubError.throwAsync(response);
  }

  if (response.status === 200) {
    return await response.json();
  }

  return undefined as T;
};
